import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.set.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.link.js";
import "core-js/modules/web.dom-collections.iterator.js";
import React from 'react';
import { Trans } from 'react-i18next';
import { generatePath } from 'react-router';
import i18n from 'i18next';
import { AccessLink } from '../Components/AccessLink';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function getAudienceText(_ref) {
  var id = _ref.id,
    audience = _ref.audience,
    teamIds = _ref.teamIds,
    isDeleted = _ref.isDeleted,
    tabLinks = _ref.tabLinks;
  var teamCount = _toConsumableArray(new Set(teamIds)).length;
  var accessTabLink = generatePath(tabLinks.access.link, {
    playlistId: id
  });
  if (audience === 'admin') {
    if (isDeleted) {
      return i18n.t('playlist_heading_visible_to_admins_only');
    }
    return /*#__PURE__*/_jsxs(Trans, {
      i18nKey: "playlist_heading_visible_to_admins_only_link",
      children: ['Visible to', ' ', /*#__PURE__*/_jsx(AccessLink, {
        accessTabLink: accessTabLink,
        children: "admins only"
      })]
    });
  }
  if (audience === 'teams') {
    if (isDeleted) {
      return i18n.t('playlist_heading_visible_to_team', {
        count: teamCount
      });
    }
    return /*#__PURE__*/_jsxs(Trans, {
      i18nKey: "playlist_heading_visible_to_team_link",
      count: teamCount,
      children: ['Visible to', ' ', /*#__PURE__*/_jsx(AccessLink, {
        accessTabLink: accessTabLink,
        children: "count teams"
      })]
    });
  }
  if (isDeleted) {
    return i18n.t('playlist_heading_visible_to_everyone');
  }
  return /*#__PURE__*/_jsxs(Trans, {
    i18nKey: "playlist_heading_visible_to_everyone_link",
    children: ['Visible to', ' ', /*#__PURE__*/_jsx(AccessLink, {
      accessTabLink: accessTabLink,
      children: "everyone"
    })]
  });
}